import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedCatalogFeedSelectionStepWithI18n } from './delayed-catalog-feed-selection-step';

export const CatalogFeedSelectionStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CATALOG_FEED_SELECTION,
  view: DelayedCatalogFeedSelectionStepWithI18n,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
